<template>
  <div class="forfait__range">
    <div class="range__name">
      - {{ updatedForfaitTransport.id }} {{ tranche.label }}
    </div>
    <div class="range__montant">
      <span>Montant</span>
      <input
        v-model="updatedForfaitTransport.montant"
        type="text"
        class="value"
        @input="updateMode=true"
      > &nbsp;€
    </div>
    <div class="range__franco">
      <span>
        Franco
      </span>
      <input
        v-model="updatedForfaitTransport.franco"
        type="text"
        class="value"
        @input="updateMode=true"
      > &nbsp;€
    </div>
    <div class="range__libelle">
      <span>
        Libelle
      </span>
      <input
        v-model="updatedForfaitTransport.libelle"
        type="text"
        class="value"
        @input="updateMode=true"
      >
      <button
        v-show="updateMode"
        class="forfait__update"
        @click="updateForfait()"
      >valider
      </button>
    </div>
    <div class="range__action">
      <button
        class="pixel_32 icon-trash"
        @click="deleteForfait(tranche.forfait.id)"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tranche: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      updateMode: false,
      updatedForfaitTransport: {
        id: this.tranche.forfait.id,
        libelle: this.tranche.forfait.libelle,
        montant: this.tranche.forfait.montant > 0 ? this.tranche.forfait.montant : 0,
        franco: this.tranche.forfait.franco > 0 ? this.tranche.forfait.franco : 0
      }
    }
  },
  methods: {
    deleteForfait(forfaitId) {
      this.$emit('deleteForfait', forfaitId)
    },
    updateForfait() {
      this.$emit('updateForfait', this.updatedForfaitTransport)
      this.updateMode = false
    }
  }
}
</script>
<style scoped>
  .forfait__range {
    display: grid;
    grid-template-columns: 20% 10% 10% 16% 5% 1fr;
    padding: 3px 2px;
    gap: 15px;
  }

  .forfait__range > div {
    display: flex;
    align-items: center;
  }

  .forfait__range > div span {
    margin-right: 0.5rem;
  }

  .range__name {
    font-weight: bold;
  }
  .range__action {
    justify-content: center;
  }

  .value {
    padding: 0 0.4rem;
    background-color: #ffffff;
  }

</style>
